import { MdArrowBack } from 'react-icons/md';
import propTypes from 'prop-types';
import * as S from './styles';

const StepLayout = ({ children, onBack, title, footer, emptyTitle }) => {
  const hasHeader = !!onBack || !!title || emptyTitle;

  return (
    <S.Wrapper>
      {hasHeader && (
        <S.LayoutHeader>
          {onBack ? (
            <S.BackButton onClick={onBack}>
              <MdArrowBack size={24} />
            </S.BackButton>
          ) : (
            <S.HeaderSpacer />
          )}
          {title && <S.HeaderTitle>{title}</S.HeaderTitle>}
          <S.HeaderSpacer />
        </S.LayoutHeader>
      )}
      <S.ContentWrapper hasHeader={hasHeader} hasFooter={!!footer}>
        {children}
      </S.ContentWrapper>
      {footer && <S.Footer>{footer}</S.Footer>}
    </S.Wrapper>
  );
};

export default StepLayout;

StepLayout.propTypes = {
  children: propTypes.any.isRequired,
  onBack: propTypes.func,
  title: propTypes.string,
  emptyTitle: propTypes.bool,
  footer: propTypes.any,
};

StepLayout.defaultProps = {
  onBack: null,
  title: null,
  footer: null,
  emptyTitle: false,
};
